/**
 * 独家资源喇叭/非喇叭体系的统一判断与分流。
 *
 * 喇叭体系与非喇叭体系录入的数据结构不同，详情（Detail）、协同端（DetailExternal）、
 * 变更记录（onTransformDiffData）三处共用同一套口径：不依赖租户，只要行内出现任一
 * 喇叭特征字段，即判定为喇叭体系。字段定义集中在此处，避免多端漂移。
 */

/** 喇叭体系特征字段：行内含其一即判定为喇叭体系 */
export const HORN_EXCLUSIVE_RESOURCE_FIELDS = [
  'influencerInfoDetails', // 达人列表（详情态为嵌套数组）
  'platform',
  'mcnName',
  'proofAttachment',
  'nickname', // 达人字段（diff 态已扁平到行顶层）
  'homePageUrl',
  'exclusiveAuthorizationProof',
];

/** 任一行含任一喇叭特征字段即为喇叭体系 */
export const isHornExclusiveResource = (rows: any[]): boolean =>
  rows.some((row: any) =>
    HORN_EXCLUSIVE_RESOURCE_FIELDS.some((field) => row?.[field] != null)
  );

/**
 * 按喇叭/非喇叭体系分流独家资源明细。
 * 喇叭体系扁平化 influencerInfoDetails（按达人拆行，附 $rowSpan/$index）；非喇叭体系原样返回。
 */
export const splitExclusiveResourceDetails = (
  exclusiveResourceDetails: any[]
): {
  hornExclusiveResourceDetails: any[];
  normalExclusiveResourceDetails: any[];
} => {
  if (!isHornExclusiveResource(exclusiveResourceDetails)) {
    return {
      hornExclusiveResourceDetails: [],
      normalExclusiveResourceDetails: exclusiveResourceDetails,
    };
  }

  const hornExclusiveResourceDetails: any[] = [];
  exclusiveResourceDetails.forEach((item: any, i: number) => {
    const influencers = item.influencerInfoDetails;
    if (Array.isArray(influencers) && influencers.length > 0) {
      influencers.forEach((influencer: any, index: number) => {
        hornExclusiveResourceDetails.push({
          ...influencer,
          ...item,
          influencerInfoDetails: undefined,
          $rowSpan: index === 0 ? influencers.length : 0,
          $index: i,
        });
      });
    } else {
      hornExclusiveResourceDetails.push({
        ...item,
        influencerInfoDetails: undefined,
        $rowSpan: 1,
        $index: i,
      });
    }
  });

  return {
    hornExclusiveResourceDetails,
    normalExclusiveResourceDetails: [],
  };
};
